<template>
  <div class="page-comp-return">
    <jw-modal :visible="data.visible" @ok="recipientOk" @cancel="handleCancel" :ok-loading="data.loading" title-align="start" width="600px" class="recipient">
      <template #title> {{ data.title }} </template>
      <jw-form :model="data.form" label-align="left" class="recipient-form" ref="returnForm" @submit="handleSubmit">
        <jw-form-item field="returnCause" :rules="rules" :validate-trigger="['change', 'input', 'blur']" :label-col-style="{ width: '150px' }" class="recipient-form-item form-label-text">
          <template #label>
            <xl-label-text :value="$t('退回原因')" :row="1" />
          </template>
          <jw-textarea
            v-model="data.form.returnCause"
            :placeholder="$t('请填写退回原因')"
            class="recipient-form-item-value"
            :auto-size="{
              minRows: 3,
              maxRows: 5
            }"
            :max-length="5000"
          />
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, inject, ref } from 'vue';
import { Message } from '@arco-design/web-vue';
import { leadsService } from '@/api/';
import { useI18n } from 'vue-i18n';
import { confine } from '@/utils/const';
const { t } = useI18n();
const returnForm = ref();
const emits = defineEmits(['cb']);
const returnShow = (record) => {
  data.visible = true;
  data.id = record.ids;
  data.title = record.title;
  returnForm.value?.resetFields();
};
const data = reactive({
  visible: false,
  id: [],
  title: [],
  type: inject('detailParams')?.entity, //模块标识
  loading: false,
  form: {
    returnCause: ''
  }
});

const rules = {
  required: true,
  validator: (value, cb) => {
    if (value) {
      if (value?.length >= confine.number20000) {
        cb(`录入字符数已达上限${confine.number20000}位，请检查`);
      }
    } else {
      cb(`请填写退回原因`);
    }
  }
};

// 取消按钮
const handleCancel = () => {
  data.visible = false;
};
// 退回接口
const returnClue = async () => {
  data.loading = true;
  try {
    const params = {
      businessIds: data.id,
      message: data.form.returnCause
    };
    const json = await leadsService.clueBack(params);
    if (!json.error) {
      Message.success(t('操作成功'));
      emits('cb');
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
    data.loading = false;
    handleCancel();
  } catch (e) {
    data.loading = false;
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
const handleSubmit = ({ values, errors }) => {
  console.log('接口', values, errors);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    returnForm.value.setFields(errorArray);
    return;
  }
  returnClue();
};
const recipientOk = () => {
  returnForm.value.handleSubmit();
};
defineExpose({ returnShow });
</script>
<style scoped lang="less">
@import './xl-return.less';
</style>
